import React from 'react';
import { Typography } from '@mui/material';

const GoalDetails = ({ allGoalData, subGoalIndex }) => {
  const goalSentence =
    allGoalData?.GoalDetails?.GoalSentence || allGoalData?.GoalSentence || '';
  const antecedent =
    allGoalData?.DataCollection?.antecedent?.Antecedent ||
    allGoalData?.dataCollection?.DataCollection?.antecedent?.Antecedent;
  const targetBehavior =
    allGoalData?.DataCollection?.targetBehavior?.TargetBehavior ||
    allGoalData?.dataCollection?.DataCollection?.targetBehavior?.TargetBehavior;
  const byDate =
    allGoalData?.DataCollection?.ByDate ||
    allGoalData?.dataCollection?.DataCollection?.ByDate ||
    '-';
  const subgoals =
    allGoalData?.HasSubgoal?.Subgoals ||
    allGoalData?.dataCollection?.HasSubgoal?.Subgoals ||
    [];
  const measurementType =
    allGoalData?.dataCollection?.DataCollection?.measurementType?.Type ||
    allGoalData?.DataCollection?.measurementType?.Type;
  const measurementUnit =
    measurementType === 'Percentage'
      ? '%'
      : ['Duration', 'Frequency'].includes(measurementType)
      ? 'times'
      : '';
  const dataType =
    allGoalData?.dataCollection?.DataCollection?.measurementType?.DataType ||
    allGoalData?.DataCollection?.measurementType?.DataType ||
    '';
  const trialsMin =
    allGoalData?.dataCollection?.DataCollection?.measurementType?.TrailsValue
      ?.TrailsMin ||
    allGoalData?.DataCollection?.measurementType?.TrailsValue?.TrailsMin;
  const trialsMax =
    allGoalData?.dataCollection?.DataCollection?.measurementType?.TrailsValue
      ?.TrailsMax ||
    allGoalData?.DataCollection?.measurementType?.TrailsValue?.TrailsMax;

  // Determine selected prompting level (main goal level)
  const promptingLevelSelected =
    allGoalData?.dataCollection?.DataCollection?.measurementType
      ?.PromptingLevel ||
    allGoalData?.DataCollection?.measurementType?.PromptingLevel ||
    '';

  const formatPromptingLevel = (pl) => {
    if (!pl) return '';
    const lower = pl.toLowerCase();
    if (lower.includes('full') && lower.includes('physical')) {
      return 'Full Physical';
    }
    if (lower.includes('partial') && lower.includes('physical')) {
      return 'Partial Physical';
    }
    if (lower.includes('verbal')) {
      return 'Verbal';
    }
    // fallback: prettify
    return pl.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const currentSubgoal = subgoals.find(
    (subgoal) => subgoal.CurrentGoal === 'Yes'
  );

  if (goalSentence) {
    return <Typography sx={{ fontFamily: 'Lato' }}>{goalSentence}</Typography>;
  }
  if (currentSubgoal) {
    const target =
      currentSubgoal?.Target === 'Atleast'
        ? 'at least'
        : currentSubgoal?.Target === 'Atmost'
        ? 'at most'
        : currentSubgoal?.Target?.toLowerCase();
    const targetDuration = currentSubgoal?.Measurement;
    const consecutiveTarget = currentSubgoal?.ConsecutiveTargetDuration
      ? 'consecutive'
      : '';
    const consecutiveTrials = currentSubgoal?.ConsecutiveTrialDuration
      ? 'consecutive trials'
      : '';

    return (
      <Typography>
        {antecedent} {targetBehavior} {target} {targetDuration}{' '}
        {consecutiveTarget} {measurementUnit}{' '}
        {measurementType === 'Trials' && (
          <>
            {dataType} in {trialsMin} {consecutiveTrials} out of {trialsMax}{' '}
            trials{' '}
          </>
        )}
        {measurementType === 'Prompting' &&
          (currentSubgoal?.PromptingLevel || promptingLevelSelected) && (
            <>
              with{' '}
              {formatPromptingLevel(
                currentSubgoal?.PromptingLevel || promptingLevelSelected
              )}{' '}
            </>
          )}
        {currentSubgoal?.Criteria?.map((item, index) => {
          const criteriaMeasurementUnit =
            item.MeasurementType === 'Percentage'
              ? '%'
              : ['Duration', 'Frequency'].includes(item.MeasurementType)
              ? 'times'
              : '';
          const targetText =
            item?.Target === 'Atmost'
              ? 'at most'
              : item?.Target === 'Atleast'
              ? 'at least'
              : item?.Target?.toLowerCase();

          return (
            <>
              {' '}
              {index !== 0 &&
                currentSubgoal.Criteria[index - 1]?.MeasurementType !==
                  'Percentage' &&
                'with '}
              {index !== 0 &&
                currentSubgoal.Criteria[index - 1]?.MeasurementType ===
                  'Percentage' &&
                'in '}
              {index === 0 && measurementType !== 'Percentage' && 'with '}
              {index === 0 && measurementType === 'Percentage' && 'in '}
              {targetText} {item.TargetDuration}{' '}
              {item.Consecutive && 'consecutive '}
              <>
                {criteriaMeasurementUnit && `${criteriaMeasurementUnit} of `}
                {item.Variable}
              </>
            </>
          );
        })}{' '}
        {currentSubgoal?.PromptingApplicable?.isPromptingApplicable && (
          <>
            {' with '}
            {currentSubgoal?.PromptingApplicable?.PromptingType ===
            'P+ & P-' ? (
              <>
                {currentSubgoal?.PromptingApplicable?.pPlus !== 0 &&
                  `${currentSubgoal?.PromptingApplicable?.pPlus} P+`}
                {currentSubgoal?.PromptingApplicable?.pPlus !== 0 &&
                  currentSubgoal?.PromptingApplicable?.pMinus !== 0 &&
                  ' and '}
                {currentSubgoal?.PromptingApplicable?.pMinus !== 0 &&
                  `${currentSubgoal?.PromptingApplicable?.pMinus} P-`}
              </>
            ) : (
              <>
                {currentSubgoal?.PromptingApplicable?.IVP !== 0 &&
                  `${currentSubgoal?.PromptingApplicable?.IVP} IVP`}
                {currentSubgoal?.PromptingApplicable?.DVP !== 0 &&
                  (currentSubgoal?.PromptingApplicable?.IVP !== 0 ? ', ' : '') +
                    `${currentSubgoal?.PromptingApplicable?.DVP} DVP`}
                {currentSubgoal?.PromptingApplicable?.PVP !== 0 &&
                  (currentSubgoal?.PromptingApplicable?.IVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.DVP !== 0
                    ? ', '
                    : '') + `${currentSubgoal?.PromptingApplicable?.PVP} PVP`}
                {currentSubgoal?.PromptingApplicable?.GP !== 0 &&
                  (currentSubgoal?.PromptingApplicable?.IVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.DVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.PVP !== 0
                    ? ', '
                    : '') + `${currentSubgoal?.PromptingApplicable?.GP} GP`}
                {currentSubgoal?.PromptingApplicable?.PP !== 0 &&
                  (currentSubgoal?.PromptingApplicable?.IVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.DVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.PVP !== 0 ||
                  currentSubgoal?.PromptingApplicable?.GP !== 0
                    ? ', '
                    : '') + `${currentSubgoal?.PromptingApplicable?.PP} PP`}
              </>
            )}
            {currentSubgoal?.PromptingApplicable?.HasPromptingVariable &&
              ` per ${currentSubgoal?.PromptingApplicable?.PromptingVariable}`}
            {currentSubgoal?.MultipleTimesToMeetGoal
              ?.isMultipleTimesToMeetGoal === 'Yes' && (
              <>
                {' in '}
                {currentSubgoal?.MultipleTimesToMeetGoal?.NumberOfSessions}{' '}
                {currentSubgoal?.MultipleTimesToMeetGoal
                  ?.ConsecutiveSessions === 'Yes' && 'consecutive '}
                sessions
              </>
            )}
          </>
        )}{' '}
        by {byDate}.
      </Typography>
    );
  } else {
    const targetValue =
      allGoalData?.DataCollection?.measurementType?.Target ||
      allGoalData?.dataCollection?.DataCollection?.measurementType?.Target;

    const target =
      targetValue === 'Atleast'
        ? 'at least'
        : targetValue === 'Atmost'
        ? 'at most'
        : targetValue?.toLowerCase() || '';

    const targetDuration =
      allGoalData?.DataCollection?.measurementType?.TargetDuration ||
      allGoalData?.dataCollection?.DataCollection?.measurementType
        ?.TargetDuration ||
      '';

    const consecutiveTarget =
      allGoalData?.DataCollection?.measurementType?.ConsecutiveTargetDuration ||
      allGoalData?.dataCollection?.DataCollection?.measurementType
        ?.ConsecutiveTargetDuration
        ? 'consecutive'
        : '';

    const consecutiveTrials =
      allGoalData?.DataCollection?.measurementType?.ConsecutiveTrialDuration ||
      allGoalData?.dataCollection?.DataCollection?.measurementType
        ?.ConsecutiveTrialDuration
        ? 'consecutive trials'
        : '';

    const criteria =
      allGoalData?.dataCollection?.DataCollection?.measurementType?.Criteria ||
      allGoalData?.DataCollection?.measurementType?.Criteria;

    return (
      <Typography>
        {antecedent}, {targetBehavior} {target} {targetDuration}{' '}
        {consecutiveTarget} {measurementUnit}{' '}
        {measurementType === 'Trials' && (
          <>
            {dataType} in {trialsMin} {consecutiveTrials} out of {trialsMax}{' '}
            trials{' '}
          </>
        )}
        {measurementType === 'Prompting' && promptingLevelSelected && (
          <>with {formatPromptingLevel(promptingLevelSelected)} </>
        )}
        {criteria?.map((item, index) => {
          const criteriaMeasurementUnit =
            item.MeasurementType === 'Percentage'
              ? '%'
              : ['Duration', 'Frequency'].includes(item.MeasurementType)
              ? 'times'
              : '';
          const targetText =
            item.Target === 'Atmost'
              ? 'at most'
              : item.Target === 'Atleast'
              ? 'at least'
              : item?.Target?.toLowerCase();

          return (
            <>
              {' '}
              {index !== 0 &&
                criteria[index - 1]?.MeasurementType !== 'Percentage' &&
                'with '}
              {index !== 0 &&
                criteria[index - 1]?.MeasurementType === 'Percentage' &&
                'in '}
              {index === 0 && measurementType !== 'Percentage' && 'with '}
              {index === 0 && measurementType === 'Percentage' && 'in '}
              {targetText} {item.TargetDuration}{' '}
              {item.Consecutive && 'consecutive '}
              <>
                {criteriaMeasurementUnit && `${criteriaMeasurementUnit} of `}
                {item.Variable}
              </>
            </>
          );
        })}{' '}
        {allGoalData?.DataCollection?.PromptingApplicable
          ?.isPromptingApplicable && (
          <>
            {' with '}
            {allGoalData?.DataCollection?.PromptingApplicable?.PromptingType ===
            'P+ & P-' ? (
              <>
                {allGoalData?.DataCollection?.PromptingApplicable?.pPlus !==
                  0 &&
                  `${allGoalData?.DataCollection?.PromptingApplicable?.pPlus} P+`}
                {allGoalData?.DataCollection?.PromptingApplicable?.pPlus !==
                  0 &&
                  allGoalData?.DataCollection?.PromptingApplicable?.pMinus !==
                    0 &&
                  ' and '}
                {allGoalData?.DataCollection?.PromptingApplicable?.pMinus !==
                  0 &&
                  `${allGoalData?.DataCollection?.PromptingApplicable?.pMinus} P-`}
              </>
            ) : (
              <>
                {allGoalData?.DataCollection?.PromptingApplicable?.IVP !== 0 &&
                  `${allGoalData?.DataCollection?.PromptingApplicable?.IVP} IVP`}
                {allGoalData?.DataCollection?.PromptingApplicable?.DVP !== 0 &&
                  (allGoalData?.DataCollection?.PromptingApplicable?.IVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.DataCollection?.PromptingApplicable?.DVP} DVP`}
                {allGoalData?.DataCollection?.PromptingApplicable?.PVP !== 0 &&
                  (allGoalData?.DataCollection?.PromptingApplicable?.IVP !==
                    0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.DVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.DataCollection?.PromptingApplicable?.PVP} PVP`}
                {allGoalData?.DataCollection?.PromptingApplicable?.GP !== 0 &&
                  (allGoalData?.DataCollection?.PromptingApplicable?.IVP !==
                    0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.DVP !== 0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.PVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.DataCollection?.PromptingApplicable?.GP} GP`}
                {allGoalData?.DataCollection?.PromptingApplicable?.PP !== 0 &&
                  (allGoalData?.DataCollection?.PromptingApplicable?.IVP !==
                    0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.DVP !== 0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.PVP !== 0 ||
                  allGoalData?.DataCollection?.PromptingApplicable?.GP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.DataCollection?.PromptingApplicable?.PP} PP`}
              </>
            )}
            {allGoalData?.DataCollection?.PromptingApplicable
              ?.HasPromptingVariable &&
              ` per ${allGoalData?.DataCollection?.PromptingApplicable?.PromptingVariable}`}
          </>
        )}
        {allGoalData?.dataCollection?.DataCollection?.PromptingApplicable
          ?.isPromptingApplicable && (
          <>
            {' with '}
            {allGoalData?.dataCollection?.DataCollection?.PromptingApplicable
              ?.PromptingType === 'P+ & P-' ? (
              <>
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.pPlus !== 0 &&
                  `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.pPlus} P+`}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.pPlus !== 0 &&
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.pMinus !== 0 &&
                  ' and '}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.pMinus !== 0 &&
                  `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.pMinus} P-`}
              </>
            ) : (
              <>
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.IVP !== 0 &&
                  `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.IVP} IVP`}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.DVP !== 0 &&
                  (allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.IVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.DVP} DVP`}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.PVP !== 0 &&
                  (allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.IVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.DVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.PVP} PVP`}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.GP !== 0 &&
                  (allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.IVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.DVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.PVP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.GP} GP`}
                {allGoalData?.dataCollection?.DataCollection
                  ?.PromptingApplicable?.PP !== 0 &&
                  (allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.IVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.DVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.PVP !== 0 ||
                  allGoalData?.dataCollection?.DataCollection
                    ?.PromptingApplicable?.GP !== 0
                    ? ', '
                    : '') +
                    `${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.PP} PP`}
              </>
            )}
            {allGoalData?.dataCollection?.DataCollection?.PromptingApplicable
              ?.HasPromptingVariable &&
              ` per ${allGoalData?.dataCollection?.DataCollection?.PromptingApplicable?.PromptingVariable}`}
            {allGoalData?.DataCollection?.MultipleTimesToMeetGoal
              ?.MultipleTimesToMeetGoal === 'Yes' && (
              <>
                {' in '}
                {
                  allGoalData?.DataCollection?.MultipleTimesToMeetGoal
                    ?.NumberOfSessions
                }{' '}
                {allGoalData?.DataCollection?.MultipleTimesToMeetGoal
                  ?.ConsecutiveSessions === 'Yes' && 'consecutive '}
                sessions
              </>
            )}
            {allGoalData?.dataCollection?.DataCollection
              ?.MultipleTimesToMeetGoal?.MultipleTimesToMeetGoal === 'Yes' && (
              <>
                {' in '}
                {
                  allGoalData?.dataCollection?.DataCollection
                    ?.MultipleTimesToMeetGoal?.NumberOfSessions
                }{' '}
                {allGoalData?.dataCollection?.DataCollection
                  ?.MultipleTimesToMeetGoal?.ConsecutiveSessions === 'Yes' &&
                  'consecutive '}
                sessions
              </>
            )}
          </>
        )}{' '}
        {allGoalData?.DataCollection?.MultipleTimesToMeetGoal
          ?.MultipleTimesToMeetGoal === 'Yes' && (
          <>
            {' in '}
            {
              allGoalData?.DataCollection?.MultipleTimesToMeetGoal
                ?.NumberOfSessions
            }{' '}
            {allGoalData?.DataCollection?.MultipleTimesToMeetGoal
              ?.ConsecutiveSessions === 'Yes' && 'consecutive '}
            sessions
          </>
        )}
        {allGoalData?.dataCollection?.DataCollection?.MultipleTimesToMeetGoal
          ?.MultipleTimesToMeetGoal === 'Yes' && (
          <>
            {' in '}
            {
              allGoalData?.dataCollection?.DataCollection
                ?.MultipleTimesToMeetGoal?.NumberOfSessions
            }{' '}
            {allGoalData?.dataCollection?.DataCollection
              ?.MultipleTimesToMeetGoal?.ConsecutiveSessions === 'Yes' &&
              'consecutive '}
            sessions
          </>
        )}{' '}
        {measurementType === 'Prompting' &&
          (currentSubgoal?.PromptingLevel || promptingLevelSelected) && (
            <>
              with{' '}
              {formatPromptingLevel(
                currentSubgoal?.PromptingLevel || promptingLevelSelected
              )}{' '}
            </>
          )}
        by {byDate}.
      </Typography>
    );
  }
};

export default GoalDetails;
